import { useCallback } from 'react';
import { useShowLogin } from 'js/hooks/useShowLogin';

export const useOnLoginButtonClick = () => {
    const showLogin = useShowLogin();

    return useCallback((): void => {
        showLogin({ afterLoginUrl: window.location.pathname });
    }, [showLogin]);
};
